import { createServerFn } from '@tanstack/react-start';

import { evaluateDevTools } from '@/devTools/utils.server';
import { devToolOverridesMiddleware } from '@/middleware/dev-tool-overrides';
import { sessionMiddleware } from '@/middleware/session';
import { userInfoMiddleware } from '@/middleware/user-info';

export const loadDevTools = createServerFn({ method: 'GET' })
  .middleware([sessionMiddleware, userInfoMiddleware, devToolOverridesMiddleware])
  .handler(async ({ context: { session, user, devToolOverrides } }) => {
    const email = user.email;
    const tenantId = session.tenantId || '';

    return evaluateDevTools(email, tenantId, devToolOverrides);
  });
